import Link from "next/link";
import { categoryOf, coverageForTemplate, templateSlug, type TemplateSeed } from "@/lib/library";
import { TEMPLATE_REPORT } from "@/lib/reportLinks";

export function TemplateCard({ t, draft = false, toBuilder = false }: { t: TemplateSeed; draft?: boolean; toBuilder?: boolean }) {
  const cat = categoryOf(t.category);
  const live = !draft && !!TEMPLATE_REPORT[t.id];
  const coverage = coverageForTemplate(t).slice(0, 3);
  // Status: live in builder → has a body but no report → draft (no body yet).
  const status = draft
    ? { label: "Coming soon", cls: "text-amber-700" }
    : live
      ? { label: "In the builder", cls: "text-emerald-deep" }
      : { label: "On request", cls: "text-muted" };
  // toBuilder (paid landing pages): live cards deep-link straight into the
  // builder instead of the template page — one hop from ad to product.
  const href = toBuilder && live ? `/builder/?report=${TEMPLATE_REPORT[t.id]}` : `/templates/${templateSlug(t)}/`;
  return (
    <Link href={href} className="lift group flex flex-col rounded-xl border border-line bg-white p-5">
      <div className="flex items-center justify-between gap-2">
        <span className="rounded-md bg-emerald-tint px-2 py-0.5 text-[0.64rem] font-semibold uppercase tracking-wider text-emerald-deep">
          {cat.label}
        </span>
        <span className={`flex items-center gap-1 text-[0.62rem] font-semibold uppercase tracking-wider ${status.cls}`}>
          {draft && <span className="h-1.5 w-1.5 rounded-full bg-amber-500" aria-hidden="true" />}
          {status.label}
        </span>
      </div>
      <h3 className="mt-3 font-display text-[1.05rem] font-bold leading-snug text-ink group-hover:text-emerald-deep">
        {t.title}
      </h3>
      <p className="mt-2 text-sm text-muted">{t.trade} · {t.task}</p>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {coverage.map((item) => (
          <span key={item} className="rounded-full bg-mist px-2.5 py-1 text-[0.68rem] font-medium text-muted">
            {item}
          </span>
        ))}
      </div>
      <div className="mt-auto flex items-center gap-1.5 border-t border-line pt-3 text-sm font-semibold text-emerald-deep">
        {draft ? "Preview draft" : live ? "Build this RAMS" : "View template"}
        <span className="transition-transform group-hover:translate-x-0.5">→</span>
      </div>
    </Link>
  );
}
